import pb from "../../../lib/pocketbase";
import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import LoadingScreen from "../../LoadingScreen";

export default function AuthRedirecter() {
    const navigate = useNavigate();
    const location = useLocation();

    const allowedUrls = ["/studio/login", "/studio/registrate"];

    useEffect(() => {
        const interval = setInterval(() => {
            if (!pb.authStore.isValid && !allowedUrls.includes(location.pathname)) {
                pb.authStore.clear();
                navigate("/studio/login");
                return;
            }
            if (!pb.authStore.model?.access && !allowedUrls.includes(location.pathname)) {
                pb.authStore.clear();
                navigate("/no-access");
                return;
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [location]);

    useEffect(() => {
        if (pb.authStore.isValid) {
            pb.collection("users").authRefresh();
        }
    }, [location]);

    if (pb.authStore.isValid && pb.authStore.model?.access) {
        return <Outlet />;
    } else {
        if (allowedUrls.includes(location.pathname)) {
            return <Outlet />;
        } else {
            return <LoadingScreen />;
        }
    }
}
